import * as React from 'react'
import classnames from 'classnames'

import { Input } from 'reactstrap'

type TextAreaType = 'grey' | 'white'

export interface TextAreaProps {
  name?: string
  value?: string
  type: TextAreaType
  className?: string
  maxLength?: number
  onChange: (e) => void
}

class TextArea extends React.PureComponent<TextAreaProps> {
  render() {
    const { name, type, value, onChange, className, maxLength } = this.props

    const valueLength = value && value.length || 0
    let maxLengthText
    if (maxLength && maxLength > 0) {
      maxLengthText = `${valueLength} / ${maxLength}`
    }

    return (
      <div className={classnames('ggtextarea', { 'ggtextarea--grey': type === 'grey' }, className)}>
        <Input name={name} type="textarea" value={value} onChange={onChange} />
        {maxLength && maxLength > 0 &&
          <div className="maxlength-container">
            <span className={classnames('maxlength', { '-error': valueLength > maxLength })}>{maxLengthText}</span>
          </div>
        }
      </div>
    )
  }
}

export default TextArea



// WEBPACK FOOTER //
// ./src/common/TextArea.component.tsx